import React, { useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ProductCard from "./ProductCard";

const ProductsByCordon = () => {
  const { type } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const title = useMemo(() => `Produits – Cordon ${type} | Deenzine`, [type]);

  useEffect(() => {
    setLoading(true);
    fetch(`/api/products/cordon/${encodeURIComponent(type)}`)
      .then((res) => res.json())
      .then((data) => {
        setProducts(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [type]);

  return (
    <div className="page">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={`Découvrez nos sacs en crochet faits main avec cordon ${type}. Pièces uniques en séries limitées, expédition rapide en France.`} />
        <link rel="canonical" href={`https://www.deenzine.com/cordon/${encodeURIComponent(type)}`} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Deenzine" />
        <meta property="og:url" content={`https://www.deenzine.com/cordon/${encodeURIComponent(type)}`} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={`Sacs en crochet faits main avec cordon ${type}, séries limitées.`} />
        <meta property="og:image" content="https://www.deenzine.com/images/og-deenzine.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:image" content="https://www.deenzine.com/images/og-deenzine.jpg" />
      </Helmet>

      <Navbar />

      <section className="section">
        <div className="container">
          <div className="card cardPad">
            <h1 className="h2" style={{ color: "var(--brand)" }}>Cordon {type}</h1>
            <p className="p">Sélection de modèles disponibles.</p>
          </div>

          <div style={{ height: 18 }} />

          {loading ? (
            <div className="card cardPad">Chargement…</div>
          ) : products.length === 0 ? (
            <div className="card cardPad">Aucun produit trouvé.</div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 18 }}>
              {products.map((product) => (
                <ProductCard
                  key={product.id}
                  productId={product.id}
                  image={product.image}
                  name={product.name}
                  price={product.price}
                  promo_price={product.promo_price}
                  promo_active={product.promo_active}
                  colors={product.colors}
                />
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProductsByCordon;
